export default {
  translation: {
    common: {
      accept: 'Prijať',
      alreadyUser: 'Už máte účet?',
      and: 'a',
      backToLogin: 'Späť na prihlasovaciu stránku',
      continueWith: 'Pokračovať s {{provider}}',
      coreNotFound: 'Nepodarilo sa načítať základné nastavenia',
      createAccount: 'Vytvoriť účet',
      createYourAccount: 'Vytvorte si účet',
      emailOrUsername: 'Email alebo používateľské meno',
      invalidUsernameOrPassword: 'Neplatné používateľské meno alebo heslo',
      localRegistrationDisabled: 'Lokálna registrácia je zakázaná administrátorom',
      login: 'Prihlásiť sa',
      logInToBoards: 'Prihlásiť sa',
      newToBoards: 'Nový v 4ga Boards?',
      noInternetConnection: 'Žiadne pripojenie na internet',
      pageNotFound_title: 'Stránka nenájdená',
      password: 'Heslo',
      policyNotAccepted: 'Prijmite prosím Všeobecné podmienky a Ochrana osobných údajov',
      privacyPolicy: 'Ochrana osobných údajov',
      register: 'Registrovať',
      registerWithGoogle: 'Registrovať cez Google',
      registrationDisabled: 'Registrácia používateľov je zakázaná administrátorom',
      serverConnectionFailed: 'Pripojenie k serveru zlyhalo',
      ssoRegistrationDisabled: 'SSO registrácia je zakázaná administrátorom',
      termsOfService: 'Všeobecné podmienky',
      togglePasswordVisibility: 'Zobraziť/skryť heslo',
      unknownError: 'Neznáma chyba, skúste neskôr',
    },

    action: {
      logIn: 'Prihlásiť sa',
    },
  },
};
